import { Component, Input, EventEmitter, Output, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import { DYNAMIC_FIELDSET_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { Publication } from 'app/fs/res/publication/model/publication';

import { HisGlobalDataService } from 'hisng';
import { DATA_SERVICE_KEY_CHILD_PUBLICATION, DATA_SERVICE_KEY_PUBLICATION } from '../../../model/constants';

@Component( {
    selector: 'res-publication-research-tab',
    templateUrl: './publication-research-tab.component.html',
    providers: [ProviderManager.getComponentProvider(PublicationResearchTabComponent)],
} )
export class PublicationResearchTabComponent {
    @Input() publication: Publication;
    @Input() childPublication: Publication;
    @Output() publicationChange = new EventEmitter<Publication>();
    @ViewChildren( DYNAMIC_FIELDSET_ANCHOR, { read: ViewContainerRef } )
        fieldsetViewContainerList: QueryList<ViewContainerRef>;

    constructor(private globalDataService: HisGlobalDataService) {}

    onBeforeNavigate() {
        this.globalDataService.setData(DATA_SERVICE_KEY_PUBLICATION, this.publication);
        if (this.childPublication) {
            this.globalDataService.setData(DATA_SERVICE_KEY_CHILD_PUBLICATION, this.childPublication);
        }
    }
}
